'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _tokensTheme = require('../../design-tokens/tokens.theme.js');

var _tokensTheme2 = _interopRequireDefault(_tokensTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ThemeProvider Kalo Theme
 * 
 * This is the core CSS-in-JS theme that is passed in to the
 * global ThemeProvider. It is mainly composed of our core
 * design tokens.
 */

var theme = (0, _extends3.default)({
  space: [0, 8, 16, 32, 64],
  breakpoints: []
}, _tokensTheme2.default);

exports.default = theme;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/theme/theme.js
// module id = 358
// module chunks = 114276838955818